import { render, staticRenderFns } from "./TeacherOutsideReviews.vue?vue&type=template&id=88015a1c&"
import script from "./TeacherOutsideReviews.vue?vue&type=script&lang=js&"
export * from "./TeacherOutsideReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports